export default "__VITE_ASSET__DIMvcFjV__"